import { callApiToServer } from "../callApi";

export async function editCourseSession(authtoken, courseObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(courseObject);

    let endUrl = "v1/auth/admin/edit-course-session";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
